// Waitlist / enrollment destination for the primary "Join" CTAs.
// Swap this to your real checkout or waitlist URL when ready
// (e.g. "https://your-checkout.samcart.com/...").
export const ENROLL_URL = "https://www.creatingwealth.community/offers/Lq4tuFu3/checkout";
export const COURSE1_URL = "https://www.creatingwealth.community/offers/bpSHFLHG/checkout";
